import Page from './profile'

export default Page
